export default __webpack_public_path__ + "static/media/Nesha_Laser_0006_Particle_7.5b170c40.png";